export const nameof = <T>(name: keyof T) => name;

export const isNoU = (o: unknown) => o === null || o === undefined;
